import React from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties";

import Sidebar from "../layouts/sidebar";
import Header from "../layouts/header";
import MobileHeader, { MOBILE_HEADER_HEIGHT } from "../layouts/mobileHeader";
import PageHeading from "../layouts/pageHeading";
import { Box, Link as MuiLink, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Cookies from "js-cookie";
import { NavLink, useSearchParams } from "react-router-dom";
import DataVerifier from "../components/DataVerifier";
import { getTokenRoles, isDataVerifierOnly } from "../utils/roles";

const CandidateVerification = () => {
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  // Phones and small tablets get a top app bar instead of the sidebar + header.
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  // A new QR link remounts the verifier with empty state, so not even a single
  // frame of the previous candidate's details can show.
  const verifierKey = searchParams.get("data") || "rollno-search";
  // Data Verifier sessions have no dashboard, so no link back to it.
  const showDashboardLink = !isDataVerifierOnly(getTokenRoles(Cookies.get("mhet_mst_token")));

  const breadcrumbs = [
    showDashboardLink && <MuiLink
      underline="hover"
      key="1"
      component={NavLink}
      to={`/${Cookies.get("mhet_mst_project")}/home`}
      sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Dashboard
    </MuiLink>,
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Admit Card Verification <MdKeyboardArrowDown size={16} />
    </Typography>,
  ].filter(Boolean);

  // The verifier stays at the same place in the tree on every screen size, so
  // crossing the breakpoint (e.g. rotating a tablet) never remounts it — no
  // camera restart, no repeated lookup, no lost result.
  return (
    <>
      {isMobile ? (
        <MobileHeader title="Admit Card Verification" />
      ) : (
        <>
          <Sidebar />
          <Header breadcrumbs={breadcrumbs} />
        </>
      )}
      <Box
        sx={
          isMobile
            ? {
                mt: `${MOBILE_HEADER_HEIGHT}px`,
                paddingX: { xs: "12px", sm: "24px" },
                paddingTop: "12px",
                paddingBottom: "24px",
              }
            : {
                // Same box as Layout.
                width: `calc(100% - ${cssProperties?.drawerWidth}px)`,
                ml: `${cssProperties?.drawerWidth}px`,
                height: `calc(100% - ${cssProperties?.headerHight}px)`,
                mt: `${cssProperties?.headerHight}px`,
                mb: "24px",
                paddingLeft: "24px",
                paddingRight: "24px",
              }
        }
      >
        {!isMobile && (
          <Grid container paddingBottom={2}>
            <Grid item md={12}>
              <PageHeading title={"Admit Card Verification"} />
            </Grid>
          </Grid>
        )}

        <DataVerifier key={verifierKey} />
      </Box>
    </>
  );
};

export default CandidateVerification;
